export interface FilingTypeDto {
  FilingTypeId?: number | null;
  Name: string;
}

export class ChangeFilingTypeDto {
  /**
   *
   */
  constructor(FilingType: number, MatterId: Guid) {
    this.FilingType = FilingType;
    this.MatterId = MatterId;
  }
  FilingType: number;
  MatterId: Guid;
}

